export const formatSerialRanges = (serialNumbers = []) => {
  const ranges = [];
  let start;
  let end;
  const appendRange = () => {
    if (start !== undefined) ranges.push(start === end ? start : `${start}–${end}`);
  };
  for (const value of serialNumbers) {
    const serial = String(value);
    if (end !== undefined && /^\d+$/.test(end) && /^\d+$/.test(serial)
      && Number(serial) === Number(end) + 1) {
      end = serial;
    } else {
      appendRange();
      start = serial;
      end = serial;
    }
  }
  appendRange();
  return ranges.join(', ');
};

export const assignBasketSerials = (items, state) => {
  const unavailable = new Set(state.unavailableSerials);
  items.filter(item => item.usesCustomSerials).forEach(item => {
    (item.serialNumbers || []).forEach(serial => {
      unavailable.add(String(serial).trim());
      if (/^\d{1,15}$/.test(String(serial).trim())) unavailable.add(String(Number(serial)));
    });
  });
  let next = state.nextSerial;
  return items.map(item => {
    if (item.usesCustomSerials) return item;
    const serialNumbers = [];
    for (let i = 0; i < item.orderQty; i += 1) {
      while (unavailable.has(String(next))) next += 1;
      serialNumbers.push(String(next++));
    }
    return { ...item, serialNumbers };
  });
};
